import React from 'react';
import PropTypes from 'prop-types';

const UserIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 9.558 7.836">
        <g fill={fill}>
            <path d="M4.782 4.965a2.483 2.483 0 10-2.477-2.482 2.485 2.485 0 002.477 2.482zm0-3.869a1.386 1.386 0 11-1.386 1.386 1.388 1.388 0 011.386-1.385z"/>
            <path d="M9.521 7.069a3.1 3.1 0 00-2.892-2.1.546.546 0 00-.362.107 2.457 2.457 0 01-2.971 0 .55.55 0 00-.362-.106 3.1 3.1 0 00-2.9 2.126.549.549 0 101.025.391 1.98 1.98 0 011.76-1.406 3.545 3.545 0 003.923 0A1.976 1.976 0 018.497 7.47a.55.55 0 001.023-.4z"/>
        </g>
    </svg>
);

UserIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

UserIcon.defaultProps = {
    width: '9.558',
    height: '7.836',
    fill: '#4b254e'
};

export default UserIcon;
